import { RCAlertBox } from '@reverbdotcom/cadence/components';
import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import DocumentBrandIcon from '@reverbdotcom/cadence/images/brand/document-orange.svg';
import stepOne from '../../../images/icons/instruction-step-1.svg';
import stepTwo from '../../../images/icons/instruction-step-2.svg';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import { TAXES_HELP_CENTER_ARTICLE_ID } from './tax_profile_helpers';

export function TaxProfileBanner() {
  const helpCenterArticleUrl = useHelpCenterArticleUrl(TAXES_HELP_CENTER_ARTICLE_ID);

  return (
    <RCAlertBox
      type="info"
    >
      <div className="g-container g-container--cycle d-flex fx-align-center mobile-d-block">
        <div className="g-col d-flex fx-align-center mr-5 g-col-mobile-12 mobile-mtb-2">
          <img
            className="mr-2 width-rem-5"
            src={DocumentBrandIcon}
            alt={I18n.t('discovery.taxProfile.banner.documentAlt')}
          />
          <div>
            <h2 className="weight-bold">
              <Translate
                text="discovery.taxProfile.banner.stepsToPrepare"
              />
            </h2>
            <Translate
              tag="span"
              text="discovery.taxProfile.banner.explanationHtml"
            >
              <a href={helpCenterArticleUrl} className="text-link">
                <Translate text="discovery.taxProfile.helpCenterLinkText" />
              </a>
            </Translate>
          </div>
        </div>
        <div className="g-col d-flex fx-align-center mr-5 g-col-mobile-12">
          <img
            className="width-rem-5"
            src={stepOne}
            alt={I18n.t('discovery.taxProfile.banner.step1Alt')}
          />
          <a href="#tin-submission" className="text-link">
            <Translate
              text="discovery.taxProfile.banner.submitYourInfo"
            />
          </a>
        </div>
        <div className="g-col d-flex fx-align-center g-col-mobile-12">
          <img
            className="width-rem-5"
            src={stepTwo}
            alt={I18n.t('discovery.taxProfile.banner.step2Alt')}
          />
          <a href="#tax-forms" className="text-link">
            <Translate
              text="discovery.taxProfile.banner.request1099"
            />
          </a>
        </div>
      </div>
    </RCAlertBox>
  );
}

export default TaxProfileBanner;
